import { useMemo } from "react";

import { useUnsavedChangesGuard } from "./useUnsavedChangesGuard";
import { confirmLeaveNavigation } from "../utils/confirmNavigation";
interface UseFormEditingGuardOptions {
  id: string;
  formDisabled: Record<string, boolean>;
  formDirty: boolean;
  message?: string;
}

export const useFormEditingGuard = ({
  id,
  formDisabled,
  formDirty,
  message,
}: UseFormEditingGuardOptions) => {
  const isEditing = useMemo(
    () => Object.values(formDisabled).some((disabled) => disabled === false),
    [formDisabled]
  );

  return useUnsavedChangesGuard({
    id,
    when: isEditing && formDirty,
    message,
  });
};

export const confirmDiscardFormEdits = async (
  formDisabled: Record<string, boolean>,
  formDirty: boolean,
  sectionKey?: string
) => {
  const isSectionEditing = sectionKey
    ? formDisabled[sectionKey] === false
    : Object.values(formDisabled).some((disabled) => disabled === false);

  if (!isSectionEditing || !formDirty) {
    return true;
  }

  return confirmLeaveNavigation(
    "You have unsaved changes. Are you sure you want to discard them?"
  );
};

export const markFormSaved = (
  markSaved: () => void,
  setFormDirty: (dirty: boolean) => void
) => {
  markSaved();
  setFormDirty(false);
};
